import { ReactElement } from 'react'
import { SerializedStyles } from '@emotion/react'

import useStyle from 'shared/hooks/useStyle'

import styles from './Dashboard.style'

type Props = {
    widgets: {
        id: string,
    }[],
    widgetComponent: (props: Record<string, unknown>) => ReactElement,
    customClasses?: {
        container?: SerializedStyles,
    },
}

const Dashboard = ({
    widgets,
    widgetComponent: Component,
    customClasses,
}: Readonly<Props>) => {
    const classes = useStyle(styles)

    return (
        <div css={[
            classes.container,
            customClasses?.container,
        ]}
        >
            {
                widgets.map((widget) => {
                    return (
                        <Component
                            key={widget.id}
                            {...widget} // eslint-disable-line react/jsx-props-no-spreading
                        />
                    )
                })
            }
        </div>
    )
}

export default Dashboard
